import type { VideoHTMLAttributes } from 'react';

import { cn } from '../../../lib/utils.js';

export interface VideoPlayerProps extends Omit<
  VideoHTMLAttributes<HTMLVideoElement>,
  'src' | 'controls'
> {
  src: string;
  /** MIME type of the source (defaults to video/mp4). */
  contentType?: string;
}

/** Native video player (WhatsApp-style) — controls + metadata preload, no transcoding. */
export function VideoPlayer({
  src,
  contentType = 'video/mp4',
  className,
  preload = 'metadata',
  ...props
}: VideoPlayerProps) {
  return (
    <video className={cn('video-player', className)} controls preload={preload} {...props}>
      <source src={src} type={contentType} />
    </video>
  );
}
